$(document).ready( function() {

	$('.view-more-butt').click( function() {
		$('.view-more').toggle();
		$('.view-more-butt label.more').toggle();
		$('.view-more-butt label.less').toggle();
	} );

});



//////////////////
// WEBPACK FOOTER
// ./assets/js/partials/_category-view-more.js
// module id = 6
// module chunks = 0